<template>
  <core-main>
    <template v-slot:title>
      {{ $t('form.dashboard.name') }}
    </template>

    <v-container class="align-center justify-center fill-height">
      <v-card>
        <v-row class="align-center justify-center text-center wrap">
          <v-col>
            <v-row>
              <v-col>
                <span
                  class="display-3 px-5"
                >
                  {{ $t('common.welcome') }}, {{ user.displayName }}.
                </span>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-avatar size="60px" item>
                  <v-gravatar :email="user.email ? user.email : ''" />
                </v-avatar>
              </v-col>
            </v-row>

            <v-row class="d-flex justify-center">
              <v-col cols="8">
                <span class="gray-text">
                  {{ $t('form.dashboard.title') }}
                </span>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <span class="font-weight-bold">
                  {{ $t('form.dashboard.learn') }}
                </span>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="8">
                <v-row justify="space-between">
                  <v-col>
                    <span class="green--text caption">
                      {{ $t('views.dashboard.options.getQuote') }}
                    </span>
                  </v-col>
                  <v-col>
                    <span class="green--text caption">
                      {{ $t('views.dashboard.options.placeOrder') }}
                    </span>
                  </v-col>
                  <v-col>
                    <span class="green--text caption">
                      {{ $t('views.dashboard.options.reviewCosts') }}
                    </span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span class="green--text caption">
                      {{ $t('views.dashboard.options.updateAccount') }}
                    </span>
                  </v-col>
                  <v-col>
                    <span class="green--text caption">
                      {{ $t('views.dashboard.options.createParts') }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </core-main>
</template>

<script>
import AuthMixin from '../../mixins/auth';

export default {
  mixins: [
    AuthMixin
  ],

  computed: {
    options() {
      return [
        'Get Instant Quote',
        'Place an order',
        'Review your parts cost',
        'Update your account preference',
        'Create your own parts catalog',
      ];
    },
  },
};
</script>
